const videoContainers = Array.from(document.querySelectorAll('.js-video'));
if (videoContainers.length) {
    videoContainers.forEach((videoContainer) => {
        // Select elements here
        const video = videoContainer.querySelector('video');
        const playButton = videoContainer.querySelector('.play');

        playButton.addEventListener('click', () => {
            video.play();
            playButton.classList.toggle('hidden');
            // video.controls = true;
        });
    });
}
